export const COMMITTED="COMMITTED";
export const VIEWED="VIEWED";
export const DISMISSED="DISMISSED";
export const COMPLETED="COMPLETED";

export const COMMITTED_ENGAGEMENT_CATEGORY = [COMMITTED,COMPLETED];

const PRIORITY_LABELS_THRESHOLDS = [
  { label: "High impact", threshold: 0.15, textIcon: " ★ " }, // top 15%
  { label: "Medium impact ", threshold:  0.50 }, // top 50%, including the "high" ones,
  { label: "Small impact", threshold: 1 } // the rest
]

export function shuffle(array) {
  array.sort(() => Math.random() - 0.5);
}

export const categorizeByPriority = (array) => {
  const arrayCopy = [...array];
  arrayCopy.sort((a,b) => b.priority - a.priority);

  const priorityGroups = PRIORITY_LABELS_THRESHOLDS.map(priorityGroup => {
    const thresholdPriority = arrayCopy[Math.min(Math.floor(priorityGroup.threshold * arrayCopy.length), arrayCopy.length-1)]?.priority;
    return { ...priorityGroup, priority: thresholdPriority };
  });

  priorityGroups.sort((a,b) => b.priority - a.priority);

  return arrayCopy.map(tip => {
    const priorityGroup = priorityGroups.find((group) => group.priority <= tip.priority);
    return { ...tip, priorityGroup }
  });
}